/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { Structure } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface StructureServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Get Structure by ID
     * Returns a structure and its properties for a given ID.
     * @param structureId ID of the structure to return
     */
    getStructureById(structureId: number, extraHttpRequestParams?: any): Observable<Structure>;

}
